import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isNullish } from '@y42/util/nullish';

function isEmptyInputValue(value: unknown): boolean {
  return isNullish(value) || ((typeof value === 'string' || Array.isArray(value)) && value.length === 0);
}

export function minNotIncludingValidator(min: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (isEmptyInputValue(control.value) || isEmptyInputValue(min)) {
      return null; // don't validate empty values to allow optional controls
    }
    const value = parseFloat(control.value);
    return !isNaN(value) && value <= min ? { min: { min: min, actual: control.value } } : null;
  };
}
